import Model, { attr, belongsTo } from "@ember-data/model";
import type HealthCentre from "parog-web/models/health-centre";
import type LearningArticle from "parog-web/models/learning-article";

export default class LearningSection extends Model {
  @attr() declare articleIds: Array<string>;
  @belongsTo("health-centre", { async: false, inverse: "learningSections" })
  declare healthCentre: HealthCentre;
  @attr("string") declare title: string | undefined;

  get articles(): Array<LearningArticle> {
    return this.articleIds.map(
      id => this.store.peekRecord("learning-article", id) as LearningArticle
    );
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "learning-section": LearningSection;
  }
}
